import { ref, watch } from 'vue';

import { useAccountStore } from '@/stores/account';

/**
 * RouterView key that stays on the last non-null business-profile id.
 *
 * Switching from one profile to another changes the key, so the page remounts.
 * Logout clears the profile (the id becomes null) and must leave the key as it
 * is: a key change remounts the current page and its mount-time fetches run
 * with no token, before the redirect to /login.
 */
export function useStickyBusinessProfileKey() {
  const accountStore = useAccountStore();
  const key = ref();

  watch(
    () => accountStore.currentBusinessProfile?.id,
    (id) => {
      if (id != null) key.value = id;
    },
    { immediate: true },
  );

  return key;
}
